<div>
	@if (dayTimezoneVisitSeries(); as dayVisitSeries) {
	<lib-card [title]="'Timezone daily visits'" [subtitle]="'Data taken from last 90 days'">
		<lib-line-chart
			[multiSeries]="dayVisitSeries"
			[xAxisLabel]="'Timezone'"
			[yAxisLabel]="'Visits'"
		></lib-line-chart>
	</lib-card>
	}
</div>

<div>
	@if (!isMobileOrTabletView() && timezonePieSeries(); as timezonePieSeries) {
	<lib-card [title]="'Timezones overview'" [subtitle]="'Data taken from last 90 days'" class="push-top-md">
		<lib-pie-chart [singleSeries]="timezonePieSeries"></lib-pie-chart>
	</lib-card>
	}
</div>

@if (visitsPerTimezoneTable(); as visitsPerTimezoneTable) {
<lib-card [title]="'Visits per timezone'" class="push-top-md">
	<lib-table [table]="visitsPerTimezoneTable"></lib-table>
</lib-card>
}
